<template lang="pug">
  div
    .isLoadingFullPage
    span.spanLoading(v-if='!!message' v-html='message')
</template>

<script>
export default {
  name: 'LoadingFullPage',

  data () {
    return {
      message: '',
      interval: null
    }
  },

  computed: {
    loadingFullPageMessages () {
      return this.$store.getters.loadingFullPageMessages
    },

    intervalBetweenMessages () {
      return this.$store.getters.intervalBetweenMessages
    }
  },

  created () {
    let counter = 1
    const intervalBetweenMessages = this.intervalBetweenMessages
    const messages = this.loadingFullPageMessages
    const length = messages.length
    if (length === 0) {
      return
    }

    const translatedMessages = messages.map(this.$t)
    this.message = translatedMessages[0]
    this.interval = setInterval(() => {
      this.message = translatedMessages[counter % length]
      ++counter
    }, intervalBetweenMessages)
  },

  beforeDestroy () {
    this.message = ''
    clearInterval(this.interval)
  }
}
</script>

<style>
.isLoadingFullPage {
  background: url(../../assets/loading-gif/loading.svg) 50% 50% no-repeat;
  background-color: #EEE;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  opacity: 0.8;
  overflow-y: hidden;
  cursor: wait;
  background-size: 150px;
  -webkit-transition: all 5s ease-in-out;
  -moz-transition: all 5s ease-in-out;
  -ms-transition: all 5s ease-in-out;
  -o-transition: all 5s ease-in-out;
  transition: all 5s ease-in-out;
}

.spanLoading {
  color: #13556A;
  font-family: 'Inter', sans-serif;
font-weight: 700;
  font-size: 25px;
  position: fixed;
  top: 49%;
  margin-top: 80px;
  width: 100%;
  text-align: center;
  z-index: 1000000;
}
</style>



// WEBPACK FOOTER //
// LoadingFullPage.vue?1ec10412